import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'cm-alphabet-filter',
  templateUrl: './alphabet-filter.component.html',
  styleUrls: ['./alphabet-filter.component.scss'],
})
export class AlphabetFilterComponent {
  @Input() letter;
  @Output() selectLetter = new EventEmitter();
  readonly ALPHABET = 'abcdefghijklmnopqrstuvwxyz'.split('');
}
